export const GOAL_HOME = 'GOAL_HOME';
export const GOAL_AWAY = 'GOAL_AWAY';
export const SHORT_PASS = 'SHORT_PASS';
export const LONG_PASS = 'LONG_PASS';
export const GK_KICK = 'GK_KICK';
export const SHOT = 'SHOT';
export const NEAR_MISS = 'NEAR_MISS';
export const Ohh = 'Ohh';
export const START_GAME = 'START_GAME';
export const GAME_END = 'GAME_END';
export const REF = 'REF';
export const LOOP = 'LOOP';
export const AWAY_MISS = 'AWAY_MISS';
export const REF_HALFTIME = 'REF_HALFTIME';
export const REF_START = 'REF_START';


/** WEBPACK FOOTER **
 ** ./src/constants/Sounds.js
 **/